export const KITS_ONE_SHOT_KEYS = {
  C: 'C',
  'C#/Db': 'C#/Db',
  D: 'D',
  'D#/Eb': 'D#/Eb',
  E: 'E',
  F: 'F',
  'F#/Gb': 'F#/Gb',
  G: 'G',
  'G#/Ab': 'G#/Ab',
  A: 'A',
  'A#/Bb': 'A#/Bb',
  B: 'B'
}

export const KITS_LOOP_AND_STEM_KEYS = {
  C: 'C',
  'C major': 'C major',
  'C minor': 'C minor',
  'C#/Db': 'C#/Db',
  'C#/Db major': 'C#/Db major',
  'C#/Db minor': 'C#/Db minor',
  D: 'D',
  'D major': 'D major',
  'D minor': 'D minor',
  'D#/Eb': 'D#/Eb',
  'D#/Eb major': 'D#/Eb major',
  'D#/Eb minor': 'D#/Eb minor',
  E: 'E',
  'E major': 'E major',
  'E minor': 'E minor',
  F: 'F',
  'F major': 'F major',
  'F minor': 'F minor',
  'F#/Gb': 'F#/Gb',
  'F#/Gb major': 'F#/Gb major',
  'F#/Gb minor': 'F#/Gb minor',
  G: 'G',
  'G major': 'G major',
  'G minor': 'G minor',
  'G#/Ab': 'G#/Ab',
  'G#/Ab major': 'G#/Ab major',
  'G#/Ab minor': 'G#/Ab minor',
  A: 'A',
  'A major': 'A major',
  'A minor': 'A minor',
  'A#/Bb': 'A#/Bb',
  'A#/Bb major': 'A#/Bb major',
  'A#/Bb minor': 'A#/Bb minor',
  B: 'B',
  'B major': 'B major',
  'B minor': 'B minor'
}
